<template>
    <SelectPlan v-if="name === 'SelectPlan'" />
    <Binoculars v-else-if="name === 'Binoculars'" />
    <Chatbot v-else-if="name === 'Chatbot'" />
    <CreditCard v-else-if="name === 'CreditCard'" />
    <Instagram v-else-if="name === 'Instagram'" />
    <Vector v-else-if="name === 'Vector'" />
    <Whatsapp v-else-if="name === 'Whatsapp'" />
    <CChatbot v-else-if="name === 'CChatbot'" />
    <CInstagram v-else-if="name === 'CInstagram'" />
    <div class="whatsapp-business-billing-svg" v-else-if="name === 'CWhatsappBusiness'">
        <WhatsappBusinessIcon />
    </div>
    <div class="whatsapp-billing-svg" v-else-if="name === 'CWhatsapp'">
        <WhatsappIcon />
    </div>
    <CSupsis v-else-if="name === 'CSupsis'" />
    <Alipay v-else-if="name === 'Alipay'" />
    <Amex v-else-if="name === 'Amex'" />
    <Diners v-else-if="name === 'Diners'" />
    <Maestro v-else-if="name === 'Maestro'" />
    <MasterCard v-else-if="name === 'Mastercard'" />
    <Paypal v-else-if="name === 'Paypal'" />
    <Visa v-else-if="name === 'Visa'" />
</template>

<script>
import Binoculars from "./svg/stepper/Binoculars.vue";
import Chatbot from "./svg/stepper/Chatbot.vue";
import CreditCard from "./svg/stepper/CreditCard.vue";
import Instagram from "./svg/stepper/Instagram.vue";
import SelectPlan from "./svg/stepper/SelectPlan.vue";
import Vector from "./svg/stepper/Vector.vue";
import Whatsapp from "./svg/stepper/Whatsapp.vue";
import CChatbot from "./svg/payment/CChatbot.vue";
import CInstagram from "./svg/payment/CInstagram.vue";
import CSupsis from "./svg/payment/CSupsis.vue";
import Alipay from "./svg/creditCard/Alipay.vue";
import Amex from "./svg/creditCard/Amex.vue";
import Diners from "./svg/creditCard/Diners.vue";
import Maestro from "./svg/creditCard/Maestro.vue";
import MasterCard from "./svg/creditCard/MasterCard.vue";
import PayPal from "./svg/creditCard/PayPal.vue";
import Visa from "./svg/creditCard/Visa.vue";
import WhatsappBusinessIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";

export default {
    name: "DynamicSvg",
    props: ["name"],
    components: {
        Binoculars,
        Chatbot,
        CreditCard,
        SelectPlan,
        Vector,
        Instagram,
        Whatsapp,
        CSupsis,
        CChatbot,
        CInstagram,
        Alipay,
        Amex,
        Diners,
        Maestro,
        MasterCard,
        PayPal,
        Visa,
        WhatsappBusinessIcon,
        WhatsappIcon,
    },
};
</script>
<style>
.whatsapp-billing-svg svg,
.whatsapp-business-billing-svg svg {
    width: 100%;
    height: 100%;
}

.whatsapp-billing-svg svg path,
.whatsapp-business-billing-svg svg path:nth-child(1) {
    fill: #58ca64 !important;
}

.whatsapp-business-billing-svg svg path[stroke-linejoin="round"] {
    stroke: #58ca64 !important;
}
</style>
